import Pedido from './entity/Pedido';
import ProdutoNoPedido from './entity/ProdutoNoPedido';
import { PEDIDO_CANCELADO, TIPO_DESCONTO_PORCENTAGEM } from './constants';
import Produto from './entity/Produto';
import ProdutoCompostoNoPedido from './entity/ProdutoCompostoNoPedido';

export function serialize<T>(obj: T) {
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function calcularTotalUnitarioProduto(produto: ProdutoNoPedido) {
  let totalPerguntas = 0;
  if (produto.perguntasNoPedido) {
    for (let i = 0; i < produto.perguntasNoPedido.length; i++) {
      const pergunta = produto.perguntasNoPedido[i];
      for (let j = 0; j < pergunta.respostasNoPedido.length; j++) {
        const resposta = pergunta.respostasNoPedido[j];
        totalPerguntas += resposta.preco * resposta.quantidade;
      }
    }
  }

  let preco = produto.tamanhoSelecionado.preco;
  if (produto.tamanhoSelecionado.precoPromocional > 0) {
    preco = produto.tamanhoSelecionado.precoPromocional;
  }

  return preco + totalPerguntas;
}

export function calcularTotalProduto(produto: ProdutoNoPedido) {
  return calcularTotalUnitarioProduto(produto) * produto.quantidadeNoPedido;
}

export function calcularTotalUnitarioProdutoComposto(composto: ProdutoCompostoNoPedido) {
  let totalPerguntas = 0;
  let totalPreco = 0;

  for (let i = 0; i < composto.produtos.length; i++) {
    const produto = composto.produtos[i];
    if (produto.perguntasNoPedido) {
      for (let i = 0; i < produto.perguntasNoPedido.length; i++) {
        const pergunta = produto.perguntasNoPedido[i];
        for (let j = 0; j < pergunta.respostasNoPedido.length; j++) {
          const resposta = pergunta.respostasNoPedido[j];
          totalPerguntas += resposta.preco * resposta.quantidade;
        }
      }
    }

    let preco = produto.tamanhoSelecionado.preco;
    if (produto.tamanhoSelecionado.precoPromocional > 0) {
      preco = produto.tamanhoSelecionado.precoPromocional;
    }

    if (preco > totalPreco) {
      totalPreco = preco;
    }
  }

  return totalPreco + totalPerguntas;
}

export function calcularTotalProdutoComposto(produto: ProdutoCompostoNoPedido) {
  return calcularTotalUnitarioProdutoComposto(produto) * produto.produtos[0].quantidadeNoPedido;
}

export function calcularTotalPedidos(pedidos: Pedido[], subtrairValorPrePago: boolean = false) {
  let total = 0;
  for (let i = 0; i < pedidos.length; i++) {
    const pedido = pedidos[i];
    if (pedido.status !== PEDIDO_CANCELADO) {
      total +=
        calcularTotalPedidoSemDesconto(pedido, pedido.precoDelivery) -
        calcularTotalDesconto(pedido, pedido.precoDelivery);

      if (subtrairValorPrePago) {
        total -= pedido.valorPrePago;
      }
    }
  }
  return total;
}

export function calcularTotalPedido(
  pedido: Pedido,
  precoDelivery: number,
  deliveryGratisAcimaDe?: number
) {
  return (
    calcularTotalPedidoSemDesconto(pedido, precoDelivery, deliveryGratisAcimaDe) -
    calcularTotalDesconto(pedido, precoDelivery, deliveryGratisAcimaDe)
  );
}

export function calcularTotalPedidoSemDesconto(
  pedido: Pedido,
  precoDelivery: number,
  deliveryGratisAcimaDe?: number
) {
  let total = 0;

  for (let i = 0; i < pedido.produtosNoPedido.length; i++) {
    const produto = pedido.produtosNoPedido[i];
    total += calcularTotalProduto(produto);
  }

  if (pedido.produtosCompostosNoPedido) {
    for (let i = 0; i < pedido.produtosCompostosNoPedido.length; i++) {
      const produto = pedido.produtosCompostosNoPedido[i];
      total += calcularTotalProdutoComposto(produto);
    }
  }

  if (pedido.endereco) {
    if (deliveryGratisAcimaDe && deliveryGratisAcimaDe > 0 && deliveryGratisAcimaDe <= total) {
      total += 0;
    } else {
      total += precoDelivery;
    }
  }
  return total;
}

export function calcularTotalDesconto(
  pedido: Pedido,
  precoDelivery: number,
  deliveryGratisAcimaDe?: number
) {
  if (!pedido.cupom) {
    return 0;
  }
  const total = calcularTotalPedidoSemDesconto(pedido, precoDelivery, deliveryGratisAcimaDe);
  if (total < pedido.cupom.valorMinimoPedido) {
    return 0;
  }

  if (pedido.cupom.tipo === TIPO_DESCONTO_PORCENTAGEM) {
    return total * (pedido.cupom.valor / 100);
  } else {
    return pedido.cupom.valor;
  }
}

export const celularMask = (value: number | string) => {
  if (typeof value !== 'string') {
    value = value.toString();
  }
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\) \d{1})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

export const cepMask = (value: number | string) => {
  if (typeof value !== 'string') {
    value = value.toString();
  }
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{5})(\d)/, '$1-$2');
};

export const cnpjMask = (value: number | string) => {
  if (typeof value !== 'string') {
    value = value.toString();
  }
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export function formatarDinheiro(valor?: number | string) {
  if (!valor) {
    return '0';
  }

  if (typeof valor === 'string') {
    valor = parseFloat(valor);
  }

  valor = valor.toFixed(2).replace('.', ',');
  return valor;
}

export function validarCPF(strCPF: string) {
  let soma: number;
  let resto: number;
  soma = 0;
  if (strCPF === '00000000000') return false;

  for (let i = 1; i <= 9; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;

  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function validarEmail(email: string) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }
  return false;
}

export function validarProduto(produto: ProdutoNoPedido) {
  if (produto.quantidadeNoPedido < 1) {
    throw new Error('Produto sem quantidade.');
  }
  if (produto.perguntasNoPedido) {
    for (let i = 0; i < produto.perguntasNoPedido.length; i++) {
      const pergunta = produto.perguntasNoPedido[i];
      if (pergunta.obrigatorio && pergunta.respostasNoPedido.length === 0) {
        throw new Error('Pergunta obrigatória não foi respondida.');
      }
      if (
        pergunta.temMaximoRespostas &&
        pergunta.respostasNoPedido.length > pergunta.maximoRespostas
      ) {
        throw new Error('Pergunta com mais respostas que o permitido.');
      }
    }
  }
}

export function setPrecosPromocionaisProduto(produto: Produto) {
  for (let i = 0; i < produto.tamanhos.length; i++) {
    const tamanho = produto.tamanhos[i];
    let menorPreco = tamanho.preco;
    for (let j = 0; j < tamanho.precosPromocionais.length; j++) {
      const precoPromocional = tamanho.precosPromocionais[j];
      if (precoPromocional.promocao.ativo && precoPromocional.preco < menorPreco) {
        menorPreco = precoPromocional.preco;
      }
    }
    if (menorPreco !== tamanho.preco) {
      tamanho.precoPromocional = menorPreco;
    }
  }
  return produto;
}

// export function getPrecoTamanho(tamanho: Tamanho) {
//   if (tamanho.precoPromocional > 0 && tamanho.precoPromocional < tamanho.preco) {
//     return tamanho.precoPromocional;
//   }
//   return tamanho.preco;
// }

export function range(start: number, end: number) {
  var ans = [];
  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

export const hexWithAlpha = (hexCode: string, opacity: number) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};
